import { Button } from '@/components/ui/button';
import { ButtonGroup } from '@/components/ui/button-group';
import type { AdminUserSenderSubTab } from '@/entities/admin-user.entity';
import { useState } from 'react';
import SenderAuthJobsSubtab from './sender/auth-jobs-subtab';
import SenderRunsSubtab from './sender/runs-subtab';
import SenderSessionsSubtab from './sender/sessions-subtab';
import SenderSettingsSubtab from './sender/settings-subtab';

const SUB_TABS: { id: AdminUserSenderSubTab; label: string }[] = [
	{ id: 'runs', label: 'Запуски' },
	{ id: 'sessions', label: 'Сессии' },
	{ id: 'settings', label: 'Настройки' },
	{ id: 'auth-jobs', label: 'Auth jobs' },
];

interface SenderTabProps {
	profileId: number;
	readOnly?: boolean;
	buildRunPath?: (profileId: number, runId: string) => string;
	fetchRuns?: typeof import('@/api/admin').fetchAdminUserSenderRuns;
	fetchSessions?: typeof import('@/api/admin').fetchAdminUserSenderSessions;
	fetchAuthJobs?: typeof import('@/api/admin').fetchAdminUserSenderAuthJobs;
}

export default function SenderTab({
	profileId,
	readOnly = false,
	buildRunPath,
	fetchRuns,
	fetchSessions,
	fetchAuthJobs,
}: SenderTabProps) {
	const [subTab, setSubTab] = useState<AdminUserSenderSubTab>('runs');
	const visibleTabs = readOnly ? SUB_TABS.filter(tab => tab.id !== 'settings') : SUB_TABS;

	return (
		<div className='flex flex-col gap-3'>
			<div className='flex gap-1.5 overflow-x-auto pb-1'>
				<ButtonGroup className='shrink-0'>
					{visibleTabs.map(tab => (
						<Button
							key={tab.id}
							size='sm'
							variant={subTab === tab.id ? 'secondary' : 'outline'}
							onClick={() => setSubTab(tab.id)}
						>
							{tab.label}
						</Button>
					))}
				</ButtonGroup>
			</div>

			{subTab === 'runs' && (
				<SenderRunsSubtab profileId={profileId} buildRunPath={buildRunPath} fetchRuns={fetchRuns} />
			)}
			{subTab === 'sessions' && (
				<SenderSessionsSubtab profileId={profileId} readOnly={readOnly} fetchSessions={fetchSessions} />
			)}
			{subTab === 'settings' && !readOnly && <SenderSettingsSubtab profileId={profileId} />}
			{subTab === 'auth-jobs' && (
				<SenderAuthJobsSubtab
					profileId={profileId}
					readOnly={readOnly}
					buildRunPath={buildRunPath}
					fetchAuthJobs={fetchAuthJobs}
				/>
			)}
		</div>
	);
}
